export const figure21b = {
chart: {
type: 'line',
backgroundColor: 'rgba(255, 255, 255, 0.0)',
height: 300,
plotBackgroundColor: null,
plotBorderWidth: null,
},
credits: {
enabled: false
},
title: {
text: 'Georgia'
},
subtitle: {
text: null
},
xAxis: {
categories: ['2013','2014','2015', '2016', '2020']
},
labels: {
format: '{value:,.0f}',
style: {
fontWeight: 'normal',
color: '#999999',
fontSize: '12px'
},
},
yAxis: {
min: 0,
max: 60000,
tickInterval: 10000,
labels: {
	     format: '{value:,.0f}',
	     style: {
			     fontWeight: 'normal',
			     color: '#999999',
			     fontSize: '12px'
		     },
     },
title: {
text: null,
},
},
plotOptions: {
series: {
marker: {
	 enabled: false,
	 states: {
			  hover: {
					 enabled: false
				 }
		  }
 }
},	
line: {
dataLabels: {
enabled: false
},
enableMouseTracking: true
}
},
legend: {
enabled: false,
},
colors: ['#5a99d3', '#f5b493','#a5a5a5', '#fdc201'],
series: [{
name: 'Pequeños productores',
data: [1279, 1793, 1579, 7778, 1643]
}, {
name: 'Productores no pequeños',
data: [4810, 6253, 5566, 56178, 14326]
},{
name: 'Unidades de pequeños productores dirigidas por mujeres',
data: [1053, 1507, 1234, 6108, 1865]
},{
name: 'Unidades de pequeños productores dirigidas por hombres',
data: [1388, 1933, 1737, 8482, 1234]
}]
}